// @ts-nocheck
// Public, no-login page. Opening it spawns the bot + fetches the FB login QR on
// demand, so the client just scans/clicks — no FBZipper account needed.
import React, {useEffect, useRef, useState} from 'react'
import {useParams} from 'react-router-dom'
import axios from 'axios'
import QRCode from 'react-qr-code'

const API_URL = process.env.REACT_APP_API_URL

const ConnectProfilePage = () => {
  const {id} = useParams()
  const [status, setStatus] = useState('starting') // starting | pending | ready | error
  const [url, setUrl] = useState('')
  const pollRef = useRef<any>(null)

  // This page renders OUTSIDE the <App> wrapper, so the HTML boot splash (#splash-screen)
  // is never auto-removed by LayoutProvider — hide it ourselves or the page stays on "טוען…".
  useEffect(() => {
    const splashScreen = document.getElementById('splash-screen')
    if (splashScreen) splashScreen.style.display = 'none'
    document.body.classList.remove('page-loading')
  }, [])

  useEffect(() => {
    let tries = 0
    const start = async () => {
      // Ask what this profile connects with BEFORE spawning anything. With QR
      // login off the answer comes back instantly as a /c/:code link, and we
      // hand the visitor straight over — that keeps every /connect/:id link
      // already sitting in a customer's WhatsApp working.
      try {
        const meta = await axios.get(`${API_URL}/profile-connect/${id}/qr`)
        if (meta.data?.method === 'password' && meta.data?.url) {
          window.location.replace(meta.data.url)
          return
        }
      } catch (_) {}
      try {
        await axios.post(`${API_URL}/profile-connect/${id}/start`)
      } catch (_) {}
      setStatus('pending')
      pollRef.current = setInterval(async () => {
        tries++
        try {
          const res = await axios.get(`${API_URL}/profile-connect/${id}/qr`)
          if (res.data?.method === 'password' && res.data?.url) {
            clearInterval(pollRef.current)
            window.location.replace(res.data.url)
            return
          }
          if (res.data?.status === 'ready' && res.data?.url) {
            clearInterval(pollRef.current)
            // On mobile there's no second device to scan a QR — open the login link directly.
            if (/iphone|ipad|android/i.test(navigator.userAgent || '')) {
              window.location.href = res.data.url
              return
            }
            setUrl(res.data.url)
            setStatus('ready')
          } else if (tries % 5 === 0) {
            axios.post(`${API_URL}/profile-connect/${id}/start`).catch(() => {})
          }
        } catch (_) {}
        if (tries > 60) {
          clearInterval(pollRef.current)
          setStatus('error')
        }
      }, 3000)
    }
    start()
    return () => clearInterval(pollRef.current)
  }, [id])

  const isMobile = /iphone|ipad|android/i.test(navigator.userAgent || '')

  return (
    <div dir='rtl' style={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f6fa', fontFamily: 'system-ui, sans-serif', padding: 20}}>
      <div style={{background: '#fff', borderRadius: 18, boxShadow: '0 10px 40px rgba(0,0,0,0.08)', padding: 32, maxWidth: 460, width: '100%', textAlign: 'center'}}>
        <div style={{fontSize: 26, marginBottom: 4}}>🔗 חיבור פרופיל פייסבוק</div>
        <div style={{color: '#7e8299', fontSize: 14, marginBottom: 24}}>FBZipper</div>

        {status === 'ready' ? (
          <>
            <div style={{background: '#fff', display: 'inline-block', padding: 14, borderRadius: 14, border: '1px solid #eff2f5'}}>
              <QRCode value={url} size={210} />
            </div>
            <p style={{color: '#3f4254', marginTop: 18, fontSize: 15}}>
              סרקו את הקוד מהטלפון שבו אתם מחוברים לאפליקציית פייסבוק כדי לאשר את ההתחברות.
            </p>
            {isMobile && (
              <a href={url} style={{display: 'inline-block', marginTop: 10, background: '#1877f2', color: '#fff', padding: '12px 26px', borderRadius: 10, textDecoration: 'none', fontWeight: 700}}>
                פתח באפליקציית פייסבוק
              </a>
            )}
          </>
        ) : status === 'error' ? (
          <p style={{color: '#f1416c'}}>לא הצלחנו להכין קוד התחברות כרגע. נסו לרענן את הדף בעוד רגע.</p>
        ) : (
          <div style={{padding: '30px 0'}}>
            <div className='spinner-border' style={{width: 46, height: 46, border: '4px solid #e4e6ef', borderTopColor: '#1877f2', borderRadius: '50%', display: 'inline-block', animation: 'connspin 0.8s linear infinite'}} />
            <p style={{color: '#7e8299', marginTop: 18}}>מכינים עבורכם קוד התחברות… (עד דקה)</p>
            <style>{`@keyframes connspin{to{transform:rotate(360deg)}}`}</style>
          </div>
        )}
      </div>
    </div>
  )
}

export default ConnectProfilePage
